export default function secondsLeft(rightTime: number) {
  return Math.ceil((rightTime - Date.now()) / 1000);
}
